import { render, staticRenderFns } from "./PCProfileDetail.vue?vue&type=template&id=1980f5e0"
import script from "./PCProfileDetail.vue?vue&type=script&lang=js"
export * from "./PCProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./PCProfileDetail.vue?vue&type=style&index=0&id=1980f5e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports